import { Button } from '@/components/ui/Button'
import { Spinner, ButtonSpinner, SquareCircleSpinner } from '@/components/ui/Spinner'
import { ToastProvider, useToast } from '@/components/ui/ToastProvider'
import { AppVersionLabel } from '@/components/AppVersionLabel'
import { AppLoading } from '@/components/AppLoading'
import text from '@/styles/textStyles.module.css'

/* TEMPORARY route for M1 verification only — compared against the Flutter
 * build by screenshot. Not part of the app; removed once M3's router lands. */

const TEXT_STYLES = [
  ['displayLarge', 64],
  ['displayMedium', 44],
  ['displaySmall', 36],
  ['headlineLarge', 32],
  ['headlineMedium', 28],
  ['headlineSmall', 24],
  ['titleLarge', 20],
  ['titleMedium', 18],
  ['titleSmall', 16],
  ['labelLarge', 16],
  ['labelMedium', 14],
  ['labelSmall', 12],
  ['bodyLarge', 16],
  ['bodyMedium', 14],
  ['bodySmall', 12],
] as const

function Section({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <section style={{ marginBottom: 40 }}>
      <h2 className={text.titleMedium} style={{ marginBottom: 16, opacity: 0.6 }}>
        {title}
      </h2>
      {children}
    </section>
  )
}

function Sink() {
  const toast = useToast()

  return (
    <div
      style={{
        minHeight: '100%',
        background: 'var(--primary-background)',
        padding: 32,
      }}
    >
      <p className={text.wordmark} style={{ marginBottom: 32 }}>
        Heart2Heart
      </p>

      <Section title="Typography — 15 theme styles">
        {TEXT_STYLES.map(([name, px]) => (
          <p key={name} className={text[name]} data-style={name}>
            {name} {px}px — Heart2Heart
          </p>
        ))}
      </Section>

      <Section title="Buttons — the two real presets">
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 16, alignItems: 'center' }}>
          <Button
            text="Go Test Tracking"
            onClick={() => new Promise((r) => setTimeout(r, 1500))}
          />
          <Button
            text="Send reassurance"
            onClick={() => new Promise((r) => setTimeout(r, 1500))}
          />
          <Button text="Get directions" variant="outlinedLight" />
          <Button
            text="Go back"
            variant="outlinedLight"
            style={{ ['--_bg' as string]: 'var(--sheet-bg)' }}
          />
          <Button text="Close" variant="outlinedLight" width={120} radius={90} style={{ ['--_bg' as string]: '#ffffff' }} />
        </div>
        <p className={text.bodySmall} style={{ marginTop: 8 }}>
          Перші дві — натисніть: лейбл підміняється спінером 23×23 на 1.5 c,
          повторний тап ігнорується.
        </p>
      </Section>

      <Section title="Spinners">
        <div style={{ display: 'flex', gap: 32, alignItems: 'center' }}>
          <Spinner />
          <div style={{ background: 'var(--primary)', padding: 12, borderRadius: 8 }}>
            <ButtonSpinner />
          </div>
          <SquareCircleSpinner />
        </div>
      </Section>

      <Section title="Toast (customSnacBar)">
        <div style={{ display: 'flex', gap: 16 }}>
          <Button
            text="Success toast"
            width={200}
            showLoadingIndicator={false}
            onClick={() => toast.show('Reassurance sent successfully')}
          />
          <Button
            text="Error toast"
            width={200}
            showLoadingIndicator={false}
            onClick={() => toast.show('An error occurred. Please try again.', 'var(--error)')}
          />
        </div>
      </Section>

      <Section title="AppVersionLabel">
        <AppVersionLabel />
      </Section>

      <Section title="AppLoading / SendReassuranceAnimation (пульс 600 мс)">
        <div style={{ height: 260, background: '#fff', borderRadius: 12 }}>
          <AppLoading />
        </div>
      </Section>
    </div>
  )
}

export function KitchenSink() {
  return (
    <ToastProvider>
      <Sink />
    </ToastProvider>
  )
}
